import classnames from 'classnames';
import type { FC } from 'react';
import styles from './DoughnutScore.module.scss';
function polarToCartesian(radius: number, angleInDegrees: number) {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: radius * Math.cos(angleInRadians),
    y: radius * Math.sin(angleInRadians)
  };
}
function describeArc(radius: number, endAngle: number) {
  const start = polarToCartesian(radius, 0);
  const end = polarToCartesian(radius, endAngle);
  const largeArcFlag = endAngle <= 180 ? '0' : '1';
  return `M ${start.x} ${start.y} A ${radius} ${radius} 270 ${largeArcFlag} 1 ${end.x} ${end.y}`;
}
interface MDDoughnutProps {
  score: number;
}
export const DoughnutScore: FC<MDDoughnutProps> = ({
  score = 0
}) => {
  const fill = Math.max(0, Math.min(score / 5, 0.99999));
  return <svg width="48px" height="48px" className={classnames(styles.doughnut, score >= 4 ? styles.green : styles.gray)}>
      <g transform="translate(24,24)">
        <circle r="21.5" stroke="#ECEDF0" strokeWidth="5" fill="none" />
        <path fill="none" strokeWidth="5" d={describeArc(21.5, fill * 360)} />
        <text dominantBaseline="central" textAnchor="middle">
          {score?.toPrecision(2)}
        </text>
      </g>
    </svg>;
};